import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Shield = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      stroke={stroke || 'currentColor'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2.5 4L8 2L13.5 4V7.5C13.5 13.5 8 14 8 14C8 14 2.5 13.5 2.5 7.5V4Z" />
    </svg>
  ),
)
Shield.displayName = 'Shield'

export default Shield
